import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 7V2H6v5H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
}), 'SettingsInputHdmiSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SettingsInputHdmiSharp.js
// module id = 6047
// module chunks = 2